import { Component, Inject, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatAutocompleteSelectedEvent } from '@angular/material';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { CurrencyPipe } from '@angular/common';
import * as _ from 'lodash';
import { ENTER, COMMA, SPACE, TAB } from '@angular/cdk/keycodes';
import { map } from 'rxjs/operators';

/**Service file */
import { SolutionFormService } from '../../solutionForm.service';

/**Query file */
import { ReportReviewQueryService, CategoriesQueryService, SolutionDescriptionQueryService } from '../../../../queryFiles/index';

/**Local file */
import { spekwoType, toastMsg } from '../../../../utils/index';

import { FirstLinePipe } from '../../../../pipesFiles/firstLine.pipe';

import { FetchSDNodes, SolutionDescriptionNodes, CostInitialDataModel, FlatRateInitialDataModel, ByTheFootInitialDataModel } from '../../../../models';
import { Subject, Observable } from 'rxjs';
import { ToastComponent } from '../../../../common/toast.component';
import { AuditHistoryService } from '../../../../../../../core/services/audit-history.service';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'edit-form-dialog',
    templateUrl: './editForm.component.html',
    styleUrls: ['./editForm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        FirstLinePipe,
        CurrencyPipe
    ]
})

export class EditFormDialogComponent {

    spekwoType = spekwoType;

    category: any;

    allCategoryList = [];
    searchKeyWords = [];
    matchedResult = []; // Return matched result

    dialogTitle: string;
    action: string;
    actionType: string = 'edit'

    editForm: FormGroup;
    editFormInitial: any;
    mainCategory: any;
    solType: any;
    categorydetails: any;
    loadingComponent: boolean;

    isLoading: boolean = false;
    //for category description spinner
    descLoading: boolean = false;
    enableSave: boolean = true;
    isSDLoad: boolean = false;
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    separatorKeysCodes: number[] = [ENTER, COMMA, SPACE, TAB];
    categorydetailsSubscription: Subscription;
    updateValueSubscription: Subscription;
    selectedKeywordId: number;
    keyWord: string = '';
    solutionDescriptionRes: any;
    searchTerm$ = new Subject<string[]>();
    toastMsg = toastMsg;
    defaultValue: CostInitialDataModel = {
        labourCost: 0,
        hourRate: 0,
        laborHour: 0,
        totalTM: 0,
        materialCost: 0,
        totalCost: 0
    }

    flatRateInitialValue: FlatRateInitialDataModel = {
        ni: null,
        cpi: null,
        totalCost: null
    }

    byTheFootInitialValue: ByTheFootInitialDataModel = {
        cpf: null,
        tf: null,
        totalCost: null
    }

    selectedCostOption: string = '';
    tmCostOption: string[] = ['tm', 'Flat', 'foot'];
    private _subscriptions: Subscription[] = [];

    roleId: any;
    userId: any;
    currentOrderId: number;

    @ViewChild('keywordInput') keywordInput: ElementRef;
    @ViewChild("editSpekwo") MyProp: ElementRef

    constructor(
        private formBuilder: FormBuilder,

        public dialogRef: MatDialogRef<EditFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,

        /**Service file */
        private formService: SolutionFormService,
        public auditHistoryService: AuditHistoryService,
        /** Local component */
        private toastComponent: ToastComponent,
        /**Query file */
        public reportReviewQueryService: ReportReviewQueryService,
        public categoriesQueryService: CategoriesQueryService,
        private _solutionDescriptionQueryService: SolutionDescriptionQueryService,

        /**Pipe file */
        public firstLinePipe: FirstLinePipe,
        public CurrencyPipe: CurrencyPipe,

        private route: ActivatedRoute,

    ) {

        this.action = data.action;
        this.currentOrderId = data.orderId;


        if (this.action === this.actionType) {
            this.searchKeyWords = [];
            this.dialogTitle = this.spekwoType.editCategory;
            this.category = data.category;
            this.allCategoryList = data.allCategory;
            this.searchKeyWords = data.category.keywords ? this.searchKeyWords.concat(data.category.keywords) : [];
        }
        else {
            this.dialogTitle = this.spekwoType.newCategory;
        }

        //create form
        this.editForm = this.createCategoryEditForm();
        this.editFormInitial = this.editForm.value;
    }


    ngOnInit() {
        this.roleId = window.localStorage.getItem("roleId");
        this.userId = window.localStorage.getItem('userUID');
    }

    ngOnDestroy() {
        this.categorydetailsSubscription && this.categorydetailsSubscription.unsubscribe();
        this.updateValueSubscription && this.updateValueSubscription.unsubscribe();
        this._subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
    }

    //Create form
    createCategoryEditForm() {

        this.mainCategory = this.category.categoryName; //from input
        this.solType = this.category.solution;  //from input
        this.selectedCostOption = this.category.costOption; //from input

        //Assinging cost values to pass to time and material component
        _.map(this.defaultValue, (value, key) => {
            this.defaultValue[key] = (key == "totalTM") ? this.category['totalCost'] : this.category[key];
        });
        _.map(this.flatRateInitialValue, (value, key) => {
            this.flatRateInitialValue[key] = this.category[key];
        });
        _.map(this.byTheFootInitialValue, (value, key) => {
            this.byTheFootInitialValue[key] = this.category[key];
        });

        //Assigning initial form values
        return this.formBuilder.group({
            categoryId: [this.category.categoryId],
            categoryName: [this.category.name],
            description: [this.category.description],
            reviewId: [this.category.reviewId],
            id: [this.category.id],
            subCategoryId: [this.category.subCategoryId],
            totalCost: [this.category.totalCost],
            solution: [this.category.solution],
            imagePath: [this.category.imagePath],
            solCategory: [this.category.solCategory],
            solSubCategory: [this.category.solSubCategory],
            keywords: [this.category.keywords],
            costOption: [this.category.costOption],
            hourRate: [this.category.hourRate],
            laborHour: [this.category.laborHour],
            materialCost: [this.category.materialCost],
            labourCost: [this.category.labourCost],
            totalTM: [this.category.totalTM],
            ni: [this.category.ni],
            cpi: [this.category.cpi],
            cpf: [this.category.cpf],
            tf: [this.category.tf],
            keyPrimCategory: [this.category.keyPrimCategory],
            key1: [this.category.key1],
            keyPhrase: [this.category.keyPhrase],
            key2: [this.category.key2],
            key3: [this.category.key3],
            key4: [this.category.key4],
        });

    }

    //Keyup funciton to getting searchList dynamically
    searchInterest(previousKeyList: string[]) {
        this.matchedResult = [];
        var value = this.keyWord;
        if (value) {
            var keyEntries: string[] = Object.assign([], previousKeyList);
            keyEntries.push(value);
            this.searchTerm$.next(keyEntries);
        }
    }

    //Getting macthed keywords list
    // search(terms: Observable<string[]>) {
    //     return terms.debounceTime(1000)
    //         // .distinctUntilChanged()
    //         .switchMap(term => {
    //             this.isSDLoad = true;
    //             return this.getSearchKeyWords(term)
    //         }
    //         );
    // }
    //To Get a Selected solution 
    getSelectedSolution(data: any) {
        let solution = null
        solution = data;
        //Assigning selected solution to new attribute
        _.map(solution, (value, key) => {
            // this.formBuilder[key] = solution[key];
            if (key != 'id' && this.editForm.get(key) != null) {
                this.editForm.get(key).setValue(solution[key]);
            }
            this.defaultValue[key] = solution[key];
            this.flatRateInitialValue[key] = solution[key];
            this.byTheFootInitialValue[key] = solution[key];
        });
        if (solution['keyword'].length > 0) {
            this.searchKeyWords = [];
            _.each(solution['keyword'], (data) => {
                if (data != null && data != '' && data != ' ') {
                    this.searchKeyWords.push(data);
                }
            })
        }
        this.selectedCostOption = null;
        setTimeout(() => {
            this.selectedCostOption = this.editForm.get('costOption').value;
        }, 1000);
        this.toastComponent.showToast("Replaced solution with selected solution");
        return this.selectedCostOption;
    }
    getNewKeyword(event) {
        if (event.key === "Enter" || event.key === "," || event.keyCode === 32) {
            this.searchKeyWord(this.keyWord);
        }
    }

    searchKeyWord(value: string) {

        if ((value || '').trim()) {
            this.searchKeyWords.push(value.trim().toLowerCase());
            this.editForm.get('keywords').setValue(this.searchKeyWords);
        }
        // Reset the input value
        this.keywordInput.nativeElement.value = '';
        this.keyWord = '';
        event.preventDefault();
    }

    getSearchKeyWords(searchList?: string[]) {
        // return this.formService.searchEntries(searchList)
        //     .pipe(
        //         map((data) => {
        //             var result = data['data']['allSolutionDescriptions']['nodes'];
        //             return result;
        //         })
        //     )
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        var matchQuery = _.find(this.matchedResult, { id: event.option.value });
        this.selectedKeywordId = event.option.value;

        if (matchQuery) {
            this.searchKeyWords = [];
            this.editForm.get('solution').setValue(matchQuery.solution);
            this.editForm.get('totalCost').setValue(matchQuery.cost);
            this.searchKeyWords = this.searchKeyWords.concat(matchQuery.keyword);
            // this.editForm.get('keywords').setValue(this.searchKeyWords);
        }
        this.keywordInput.nativeElement.value = '';
        this.keyWord = '';
    }


    remove(searchText: string): void {
        const index = this.searchKeyWords.indexOf(searchText);

        if (index >= 0) {
            this.searchKeyWords.splice(index, 1);
        }

        if (this.searchKeyWords.length == 0) {
            this.matchedResult = [];
            this.editForm.get('solution').setValue('');
            this.editForm.get('totalCost').setValue('');
            this.selectedKeywordId = null;
        }
        this.keyWord = '';
    }

    //selected categories 
    selectedCategories(category) {


        this.descLoading = true;
        //fetching sub_category detail from database
        this.categorydetails = this.categoriesQueryService.GET_SUB_CATEGORY_BY_ID(category)
        this.categorydetailsSubscription = this.categorydetails
            .valueChanges
            .subscribe(({ data }) => {
                if (data.allSubCategories.edges.length > 0) {


                    var firstLine = this.firstLinePipe.transform(data.allSubCategories.edges[0].node.description);
                    this.editForm.get('description').setValue(firstLine);
                    this.editForm.get('categoryId').setValue(data.allSubCategories.edges[0].node.categoryId);
                    this.editForm.get('subCategoryId').setValue(data.allSubCategories.edges[0].node.subCategoryId);
                    this.editForm.get('imagePath').setValue(data.allSubCategories.edges[0].node.imgPath);
                    // this.solType = category.categoryName; //On new change items
                    this.descLoading = false;
                }
            });

    }

    /**Enable save button once filled value */
    getInputValue(value) {

        if (value) {
            this.enableSave = true;
        }
        else {
            this.enableSave = false;
        }

    }

    //calling update function
    updateValue() {
        // this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
        this.isLoading = true;
        this.editForm.get('keywords').setValue(this.searchKeyWords);
        this.updateValueSubscription = this.reportReviewQueryService
            .UPDATE_REPORT_REVIEW(this.editForm, this.category)
            .subscribe((response) => {

                this.auditHistoryFunCall("Success");

                this.isLoading = false;
                this.storingKeywordsInDB();
                this.dialogRef.close(['save', this.editForm, 'success', this.mainCategory, this.solType])
            }, (err) => {
                this.auditHistoryFunCall("Failed");
                this.isLoading = false;
                this.dialogRef.close(['save', this.editForm, 'failed', this.mainCategory, this.solType])
            })

    }

    //Assigning all cost values
    calculatedCostValues(selected: any) {
        _.map(selected, (value, key: number) => {
            this.editForm.get(key.toString()).setValue(Number(value))
        });
    }

    //Assigning costOption to form value
    costSelection(selected: string) {
        this.selectedCostOption = selected;
        this.editForm.get('costOption').setValue(this.selectedCostOption);
        if (this.selectedCostOption != this.tmCostOption[0] || this.selectedCostOption != this.tmCostOption[1] || this.selectedCostOption != this.tmCostOption[2]) {
            _.map(this.defaultValue, (value, key) => {
                if (key != "solution") {
                    this.defaultValue[key] = 0;
                    this.editForm.get(key).setValue(0);
                }

            });
            _.map(this.flatRateInitialValue, (value, key) => {
                this.flatRateInitialValue[key] = 0;
                this.editForm.get(key).setValue(0);
            });
            _.map(this.byTheFootInitialValue, (value, key) => {
                this.byTheFootInitialValue[key] = 0;
                this.editForm.get(key).setValue(0);
            });
            this.editForm.get('totalCost').setValue(this.matchedResult[0]['cost']);
        }
    }

    // addSkillsToArray(skill) {
    //     if ((skill || '').trim()) {
    //         this.skills.push({ name: skill.trim() });
    //     }
    //     this.form.reset();
    //     event.preventDefault();
    // }

    //Updating or creating solution description
    storingKeywordsInDB() {
        this.selectedKeywordId = (this.matchedResult.length > 0) ? this.selectedKeywordId : null;
        // this.formService.storingKeywordsInDB(this.searchKeyWords, this.editForm.value.solution, this.editForm.value.totalCost, this.selectedKeywordId).then((res) => { });
    }

    //To scroll top
    scrollToTop() {
        this.isLoading = true;
        const contentContainer = document.getElementById('editSpekwo');
        contentContainer.scrollIntoView();
        this.updateValue();
    }
    loadSolutionDescriptionList() {
        this.loadingComponent = true;
    }

    auditHistoryFunCall(status) {
        let auditLogPayload = {
            roleId: this.roleId,
            userId: this.userId,
            orderId: Number(this.currentOrderId),
            newData: this.editForm.value,
            oldData: this.editFormInitial,
            auditType: "solution_estimate_edit",
            logsDesc: "Solution Estimate Updated",
            platform: "Executive Dashboard",
            status: status
        };

        this.auditHistoryService.auditHistoryCall(auditLogPayload);
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/edit-model/editForm.component.ts